module.exports = __webpack_public_path__ + "img/top.b268ea5b.png";